import { createFileRoute } from '@tanstack/react-router';
import { GlobalDashboard } from '@/features/global/GlobalDashboard';

export const Route = createFileRoute('/')({
  component: GlobalDashboard,
});
